export const variable_global = {};
